import React, { useContext } from 'react'
import AllReviews from '@components/Products/ProductReviewsSection/AllReviews'
import StarRating from '@components/common/StarRating'
import RatingBar from '@components/Products/ProductReviewsSection/RatingBar'
import Spacer from '@components/common/Spacer'
import QuickBuyContext from '@context/QuickBuyContext'
import { getProductRating } from '@utils'

const SeeAllReviews = ({ratings, reviews, fitToSize}) => {
  const { setShowWriteReview } = useContext(QuickBuyContext)

  const {
    totalReviews,
    average,
  } = getProductRating(ratings)

  return (
    <React.Fragment>
      <section className="">
        <div className="w-full flex items-center justify-between gap-x-2 md:gap-x-4">
          <div className="flex flex-wrap justify-center gap-x-2 text-center">
            <h1 className="font-normal">{isNaN(average) ? "0" : average?.toFixed(1)}</h1>
            <div className="w-full space-y-2">
              <StarRating
                className="justify-center"
                readOnly={true}
                initalRating={average}
              />
              <p>Based on ({totalReviews ? totalReviews : "0"}) reviews</p>
            </div>
          </div>

            {
                fitToSize &&
                    <div className="w-auto">
                        <h2 className="m-0 font-semibold">Fits true to size</h2>
                        <div className="flex flex-nowrap items-center gap-x-3">
                        <span>Smaller</span>
                        <div className="flex gap-x-1">
                            {[...Array(5)].map((_, index) => {
                            return (
                                <div
                                key={`fit-true-${index}`}
                                className={`h-2 min-w-6 ${
                                    index === 2 ? "bg-primary" : "bg-[#D1D1D1]"
                                }`}
                                />
                            );
                            })}
                        </div>
                        <span>Larger</span>
                        </div>
                        <div className="pt-4 spac-y-2">
                        <div className="text-[#171717] text-md font-semibold mb-1">
                            How is this calculated?
                        </div>
                        <p className="text-tertiary text-xs">
                            We calculate the fit range rating by combining customer
                            feedback, survey responses about fit, and precise product
                            measurements to help you find the right size.
                        </p>
                        </div>
                    </div>
            }
        </div>

        <Spacer height="1px" margin="mt-4 mb-5" />

        <div className="w-full flex flex-wrap">
          {reviews?.ratings?.map((item, index) => {
            return (
              <RatingBar
                key={`rating-${index + 1}`}
                starLabel={item.star}
                reviewCount={item.total}
                percentage={(item.total / totalReviews) * 100}
              />
            );
          })}
        </div>

        {/* <div className="flex justify-end pt-4">
          <button
            className="btn-primary flex items-center justify-center p-3 w-[232px]"
            onClick={() => setShowWriteReview(true)}
          >
            Write a Review
          </button>
        </div> */}

        <div className="bg-white pt-4">
          <AllReviews data={reviews} sortPosition="left" hideSeeAllButton stickySortPosition />
        </div>
      </section>
    </React.Fragment>
  );
}

export default SeeAllReviews